import { Dispatch } from "redux"
import { ActionType } from "../action-types"
import { Action } from "../actions/index"
import { erase } from "../../helper/cookieFunction"

export const langValueState = (langValue: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_LANG_VALUE,
            payload: langValue
        })
    }
}

export const freezScreenState = (mode: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_FREEZ_SCREEN,
            payload: mode
        })
    }
}

export const alertMessageState = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_ALERT_MESSAGE,
            payload: data
        })
    }
}

export const alertHideState = (mode: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_ALERT_MESSAGE,
            payload: mode
        })
    }
}

export const formDataState = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_FORMDATA,
            payload: data
        })
    }
}

export const shopUrlState = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_SHOP_URL,
            payload: data
        })
    }
}
export const userInfoState = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_USER_INFO,
            payload: data
        })
    }
}

export const setOrderEventTable = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_ORDER_EVENT_TABLE,
            payload: data
        })
    }
}



export const setLoggedIn = (data: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_LOGGED_IN,
            payload: true,
            token: data
        })
    }
}


export const setLoggedOut = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_LOGGED_IN,
            payload: false,
            token: ''
        })
        erase('tokenAuth')
        erase('Profile')

    }
}


export const setQrCode = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_QR_CODE,
            payload: data,
        })
    }
}

export const setShareQrCode = (shareQrcodePopup: any, shareQrcode: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_SHARE_QR_CODE,
            shareQrcodePopup: shareQrcodePopup,
            shareQrcode: shareQrcode
        })
    }
}


export const setQrIndex = (ind: number) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_QR_INDEX,
            payload: ind,
        })
    }
}


export const setStoreId = (id: number | null) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_STORE_ID,
            payload: id,
        })
    }
}



export const setStoreManagerList = (list: any | null) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_STORE_MANAGER_LIST,
            payload: list,
        })
    }
}
export const setSegmentSettings = (settings: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_SEGMENT_SETTINGS,
            payload: settings,
        })
    }
}
export const setCustomerSegmentInfo = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_CUSTOMER_SEGMENT_INFO,
            payload: data,
        })
    }
}

export const setPaymentMethodPopUp = (mode: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_PAYMENT_METHOD_POPUP,
            payload: mode
        })
    }
}


export const setStoreInfo = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_STORE_INFO,
            payload: data
        })
    }
}

export const setBookingDetails = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_BOOKING_DETAILS,
            payload: data
        })
    }
}
export const setExtrasFieldsPopup = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_EXTRAS_FIELDS_POPUP,
            payload: data,
        })
    }
}
export const setExtrasFields = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_EXTRAS_FIELDS,
            payload: data,
        })
    }
}
export const setCart = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_CART,
            payload: data
        })
    }
}

export const setBookingForm = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_BOOKING_FORM,
            payload: data
        })
    }
}
export const setAuthToken = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_AUTH_TOKEN,
            payload: data
        })
    }
}

export const setDeviceId = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_DEVICE_ID,
            payload: data
        })
    }
}

export const setBookingTotal = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_BOOKING_TOTAL,
            payload: data
        })
    }
}

export const setSlotsList = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_SLOTS_LIST,
            payload: data
        })
    }
}

export const setTimeCacheCreatedAt = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_TIME_CACHE_CREATED_AT,
            payload: data
        })
    }
}




export const setRedirectCheckout = (mode: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_REDIRECT_CHECKOUT,
            payload: mode
        })
    }
}

export const setLoginModal = (mode: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_LOGIN_MODAL,
            payload: mode
        })
    }
}

export const setOtpModal = (mode: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_OTP_MODAL,
            payload: mode
        })
    }
}

export const setLoginState = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_LOGIN_STATE,
            payload: data
        })
    }
}

export const setLoginSkip = (mode: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_LOGIN_SKIP,
            payload: mode
        })
    }
}

export const setGuestLoggedIn = (mode: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_GUEST_LOGGED_IN,
            payload: mode
        })
    }
}

export const setPendingCheckout = (mode: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_PENDING_CHECKOUT,
            payload: mode
        })
    }
}